import React from "react";
import { FaTh } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import { Link } from "react-router-dom";
import blogThreeData from "../services6/blogThreeData";
import projectFilterData from "../ProjectFilter/projectFilterData";
import productsData from "../data/products";

function MainMenu({ hanldeOffset }) {
  const categoryMap = new Map();

  for (const item of productsData) {
    if (!categoryMap.has(item.category)) {
      categoryMap.set(item.category, []);
    }
    categoryMap.get(item.category).push(item);
  }

  const categories = Array.from(categoryMap.entries());

  return (
    <>
      <div className="main-menu-area">
        <div className="row align-center">
          <div className="col-6 col-md-8 col-lg-10">
            {/* <div className="main-menu">
                            <ul>
                                <li>
                                    <Link to="/">Home</Link>
                                </li>
                                <li>
                                    <Link to="/about">About</Link>
                                </li>
                                <li>
                                    <Link to="/services">Services</Link>
                                </li>
                                <li>
                                    <Link to="/products">Products</Link>
                                </li> 
                            </ul>
                        </div> */}
            <div className="main-menu">
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About</Link>
                </li>
                <li>
                  <Link to="/services">Services</Link>
                  <ul className="sub-menu">
                    {blogThreeData.map((data) => (
                      <li key={data.id}>
                        <Link
                          to={`/services/${data.slug}`}
                          style={{ color: "white" }}
                        >
                          {data.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li>
                  <Link to="/products">Products</Link>
                  <ul className="sub-menu">
                    {categories.map(([category, items]) => (
                      <li key={category}>
                        <Link
                          to={`/products/${category}`}
                          style={{ color: "white" }}
                        >
                          {category} ({items.length})
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                {/* <li>
                                    <Link to="/services">Services</Link>
                                </li>
                                <li>
                                    <Link to="/products">Products</Link>
                                </li> */}
              </ul>
            </div>
          </div>
          {/* The commented-out icon-wrapper for search and side-menu toggle is preserved below */}
          {/* <div className="col-6 col-md-8 col-lg-2 icon-wrapper">
                        <button type="button" className="search-btn">
                            <i>
                                <FiSearch />
                            </i>
                        </button>
                        <button type="button" onClick={hanldeOffset} className="side-menu-toggle">
                            <FaTh />
                        </button>
                    </div> 
                    */}
        </div>
      </div>
    </>
  );
}

export default MainMenu;
